import type { UserAccount } from "@/api/queries";

import type { Broadcast, BroadcastSong, ParsedBroadcast } from "../types/broadcast.types";
import type { BroadcastFormValues } from "./broadcastSchema";

import { broadcastSongSchema } from "./broadcastSchema";

export type CreateBroadcastPayload = {
  account_name: string | undefined;
  legacy_name: string | undefined;
  song: string;
  medium: BroadcastFormValues["medium"];
  station: string;
  program?: string;
  country: string;
  date_aired: string;
  evidence: string;
};

export type UpdateBroadcastPayload = CreateBroadcastPayload & {
  id: string;
};

export function buildBroadcastPayload(
  values: BroadcastFormValues,
  account: UserAccount | null | undefined,
  works: Array<{ workcode: string; [key: string]: unknown }> | undefined,
  id?: string,
): CreateBroadcastPayload | UpdateBroadcastPayload {
  const songObj = works?.find(w => w.workcode === values.song);

  const base: CreateBroadcastPayload = {
    account_name: account?.artistaccountcode,
    legacy_name: account?.originatorcode?.code,
    song: JSON.stringify(songObj),
    medium: values.medium,
    station: values.station,
    program: values.program,
    country: values.country,
    date_aired: values.dateAired,
    evidence: values.evidence,
  };

  if (id != null) {
    const update: UpdateBroadcastPayload = { ...base, id };
    return update;
  }

  return base;
}

export function parseBroadcast(broadcast: Broadcast): ParsedBroadcast {
  let song: BroadcastSong | undefined;
  if (broadcast.song != null && broadcast.song !== "") {
    try {
      const result = broadcastSongSchema.safeParse(JSON.parse(broadcast.song));
      song = result.success ? result.data : undefined;
    }
    catch {
      song = undefined;
    }
  }
  return { ...broadcast, song };
}
